import { useCallback } from 'react';
import { ModelStatus, TagOperation, getTagInfo, getTagOperationStatus } from '../api/configurationService';
import { IModelStatus } from '../types';
import { useAppSelector } from '../redux/store';

const useModelStatus = (): IModelStatus => {
  const activeConfiguration = useAppSelector((store) => store.app.activeConfiguration);

  const getModelStatus = useCallback(async (): Promise<{ isUpdating: boolean; isUpdatable: boolean }> => {
    let status = {
      isUpdating: false,
      isUpdatable: false,
    };

    if (
      activeConfiguration.model &&
      activeConfiguration.model.serviceProvider &&
      activeConfiguration.language &&
      activeConfiguration.domain &&
      activeConfiguration.model &&
      activeConfiguration.model.name
    ) {
      const tag = `${activeConfiguration.model.serviceProvider}%3A${activeConfiguration.language}%3A${activeConfiguration.domain}%3A${activeConfiguration.model.name}`;
      try {
        await getTagInfo(tag);
        status.isUpdatable = true;
      } catch (error) {
        console.log('Model info response failed...');
      }

      try {
        const tagOperationStatus = await getTagOperationStatus(tag, TagOperation.UPDATE);
        if (tagOperationStatus.data.status === ModelStatus.RUNNING) {
          status.isUpdating = true;
        }
      } catch (error) {
        console.log('Model status response failed...');
      }
    }

    return status;
  }, [activeConfiguration]);

  return {
    getModelStatus,
  };
};

export default useModelStatus;
